import { createSelector } from 'reselect';

import { ApplicationRootState } from 'types';

const selectModalsState = (state: ApplicationRootState) => state.modals;

export const selectProps = createSelector(selectModalsState, (modals) => ({
  ...modals.props,
  date: new Date().getTime(),
}));

export const modalsSelector = createSelector(
  selectModalsState,
  (modals) => modals
);

export const selectIsModalOpen = createSelector(
  selectProps,
  (props) => props.type !== undefined
);
